module.exports = __webpack_public_path__ + "img/sqPic.0c4af7c2.jpg";